<template>
  <div>
    <kudos 
      :clientId="$store.getters.user.client_id"
      :userId="$store.getters.user.id"
    />
  </div>
</template>

<script>
import { Kudos } from 'ewage-portal-kudos'
export default {
  name: 'kudos-view',
  components: {
    Kudos
  }
}
</script>
